<template>
  <section>
    <div class="container">
      <h2>
        <div class="r">
          멍청새의 하루는 오직
        </div>
        <div class="r">
          <svgLogo />
          에서만!
        </div>
      </h2>
      <img :src="$getImgUrl(`assets/img/b.webp`)" alt="멍청새" draggable="false">
    </div>
  </section>
</template>

<script>
import svgLogo from '@/svg/svgLogo'

export default {
  components: {
    svgLogo
  }
}
</script>

<style lang="scss" scoped>

section {
  --section-gutter-top: 243px;
  --title-font-size: 44px;
  --icon-height: calc(var(--title-font-size) * 1.2);
  padding-top: var(--section-gutter-top);
  background-color: black;
  @media screen and (max-width: 600px) {
    --title-font-size: 38px;
  }
  @media screen and (max-width: 440px) {
    --title-font-size: 32px;
  }
  @media screen and (max-width: 375px) {
    --title-font-size: 27px;
  }
}

h2 {
  font-weight: 500;
  font-size: var(--title-font-size);
  color: #FFFFFF;
  text-align: center;
}

.r svg {
  display: block;
  width: auto;
  height: var(--icon-height);
  margin-right: 12px;
}

.r {
  display: flex;
  align-items: center;
  justify-content: center;
}

.r + .r {
  margin-top: 10px;
}

img {
  margin: 42px auto 0;
  width: 286px;
  max-width: 100%;
  height: auto;
  display: block;
  pointer-events: none;
}

</style>